<template>
  <div>
    <div class="groupingWrapper w-100">
      <div class="groupingTitle row">
        <div
          class="col05"
          @click="$emit('toggleExpanded', ruleGroup.id)"
        >
          <i
            v-if="isExpanded"
            class="fa fa-chevron-down mr-4 width20"
          />
          <i
            v-else
            class="fas fa-chevron-right mr-4 width20"
            placement="bottom"
          />
        </div>
        <div
          class="col90"
          @click="$emit('toggleExpanded', ruleGroup.id)"
        >
          {{ ruleGroup.name }}
        </div>
        <div class="col10 pr-4">
          <button
            v-if="canUserEdit"
            v-b-modal="'deleteRulesGrouping' + ruleGroup.id"
            v-b-tooltip.hide-overflow
            class="btn btn-danger mediumActionButton float-right mr-3"
            placement="bottom"
            title="Gruppierung löschen"
            type="button"
          >
            <i class="fas fa-trash-alt" />
          </button>
          <rule-group-configuration
            :configuration="configuration"
            :contract-id="contractId"
            :edition-id="editionId"
            :rule-group="ruleGroup"
            :version-id="versionId"
            @updated="handleChange()"
          />
        </div>
      </div>
      <div
        v-if="isExpanded"
        class="groupingContent"
      >
        <div
          class="w-100 mb-1 mt-2"
          style="height: 40px"
        >
          <rule-edit
            :configuration="configuration"
            :contract-id="contractId"
            :edition-id="editionId"
            :rule-group="ruleGroup"
            :rule-id="0"
            :version-id="versionId"
            :highest-order="highestGroupOrder"
            class="float-right mr-4"
            @ruleSaved="handleChange()"
          />

          <button
            v-if="selected.length > 0 && canUserEdit"
            v-b-tooltip.hover
            class="btn btn-primary mr-1 float-right"
            placement="bottom"
            title="Auswahl umkehren"
            type="button"
            @click="switchSelection"
          >
            <i class="fas fa-exchange-alt" />
          </button>

          <rule-bulk-edit
            v-if="selected.length > 0"
            :configuration="configuration"
            :contract-id="contractId"
            :edition-id="editionId"
            :rule-group="ruleGroup"
            :selected-rules="selected"
            :version-id="versionId"
            class="float-right"
            unique-identifier="topGrouped"
            @ruleSaved="handleChange()"
          />
          <rule-bulk-copy-move
            v-if="selected.length > 0"
            :all-groups="allGroups"
            :configuration="configuration"
            :contract-id="contractId"
            :edition-id="editionId"
            :rule-group="ruleGroup"
            :selected-rules="selected"
            :version-id="versionId"
            :order-offset="highestGroupOrder"
            class="float-right"
            unique-identifier="topGrouped"
            @ruleSaved="handleChange()"
          />

          <rule-bulk-delete
            v-if="selected.length > 0"
            :configuration="configuration"
            :contract-id="contractId"
            :edition-id="editionId"
            :selected-rules="selected"
            :version-id="versionId"
            class="float-right"
            unique-identifier="deletetopGrouped"
            @ruleSaved="handleChange()"
          />
        </div>
        <u-loader v-if="isLoading" />
        <v-data-table
          v-else
          v-model="selected"
          :headers="tableHeaders"
          :items="listItems"
          :pagination.sync="pagination"
          :rows-per-page-items="rowsPerPage"
          class="mb-2 ml-4 specialHeight"
          disable-initial-sort
          hide-actions
          item-key="id"
          select-all
          @update:pagination="handlePaginationChange"
        >
          <template v-slot:items="props">
            <td>
              <v-checkbox
                v-model="props.selected"
                hide-details
                primary
              />
            </td>
            <td
              v-for="(header, index) in tableHeaders"
              :key="index"
            >
              <div v-if="index == tableHeaders.length - 1">
                <div class="d-flex">
                  <rule-edit
                    :configuration="configuration"
                    :contract-id="contractId"
                    :edition-id="editionId"
                    :rule-group="ruleGroup"
                    :rule-id="props.item.id"
                    :version-id="versionId"
                    :highest-order="highestGroupOrder"
                    @ruleSaved="handleChange()"
                  />
                  <button
                    v-if="canUserEdit"
                    v-b-modal="'confirmDeleteGroupedRule' + ruleGroup.id"
                    v-b-tooltip.hover
                    class="btn btn-danger smallActionButton ml-1"
                    placement="bottom"
                    title="Regel löschen"
                    type="button"
                    @click="ruleToDelete = props.item.id"
                  >
                    <i class="fas fa-trash-alt" />
                  </button>
                </div>
              </div>
              <div
                v-else
                class="cursorpointer noselect"
                @dblclick="selectProperty(props.item, header)"
              >
                {{ props.item[header.value] | ruleValueDisplay }}
              </div>
            </td>
          </template>
        </v-data-table>
        <div
          class="w-100 mb-4"
          style="height: 40px"
        >
          <rule-edit
            :configuration="configuration"
            :contract-id="contractId"
            :edition-id="editionId"
            :rule-group="ruleGroup"
            :rule-id="0"
            :version-id="versionId"
            :highest-order="highestGroupOrder"
            class="float-right mr-4"
            @ruleSaved="handleChange()"
          />

          <button
            v-if="selected.length > 0 && canUserEdit"
            v-b-tooltip.hover
            class="btn btn-primary mr-1 float-right"
            placement="bottom"
            title="Auswahl umkehren"
            type="button"
            @click="switchSelection"
          >
            <i class="fas fa-exchange-alt" />
          </button>

          <rule-bulk-edit
            v-if="selected.length > 0"
            :configuration="configuration"
            :contract-id="contractId"
            :edition-id="editionId"
            :rule-group="ruleGroup"
            :selected-rules="selected"
            :version-id="versionId"
            class="float-right"
            unique-identifier="bottomGrouped"
            @ruleSaved="handleChange()"
          />

          <rule-bulk-copy-move
            v-if="selected.length > 0"
            :all-groups="allGroups"
            :configuration="configuration"
            :contract-id="contractId"
            :edition-id="editionId"
            :rule-group="ruleGroup"
            :selected-rules="selected"
            :version-id="versionId"
            class="float-right"
            unique-identifier="bottomGrouped"
            @ruleSaved="handleChange()"
          />

          <rule-bulk-delete
            v-if="selected.length > 0"
            :all-groups="allGroups"
            :configuration="configuration"
            :contract-id="contractId"
            :edition-id="editionId"
            :selected-rules="selected"
            :version-id="versionId"
            class="float-right"
            unique-identifier="deletebottomGrouped"
            @ruleSaved="handleChange()"
          />
        </div>
      </div>
    </div>
    <b-modal
      :id="'confirmDeleteGroupedRule' + ruleGroup.id"
      :ref="'confirmDeleteGroupedRule' + ruleGroup.id"
      hide-footer
      no-fade
      title="Regel Löschen"
    >
      <div class="d-block mb-4">
        Sind Sie sicher, dass sie diese gruppierte Regel löschen möchten?

        <u-error-handling
          v-if="deleteErrorObject"
          :error-object="deleteErrorObject"
        />
      </div>
      <b-button
        variant="success"
        @click="deleteGroupedRule"
      >
        Ok
      </b-button>
      <b-button
        class="ml-2"
        variant="danger"
        @click="hideModal('confirmDeleteGroupedRule' + ruleGroup.id)"
      >
        Abbrechen
      </b-button>
    </b-modal>
    <b-modal
      :id="'deleteRulesGrouping' + ruleGroup.id"
      :ref="'deleteRulesGrouping' + ruleGroup.id"
      hide-footer
      no-fade
      title="Gruppierung Löschen"
    >
      <div class="d-block mb-4">
        <p>Sind Sie sicher, dass sie diese Gruppierung löschen möchten?</p>
        <p>Alle Regeln in dieser Gruppierung werden auch gelöscht</p>
        <u-error-handling
          v-if="deleteErrorObject"
          :error-object="deleteErrorObject"
        />
      </div>
      <b-button
        variant="success"
        @click="deleteGrouping"
      >
        Ok
      </b-button>
      <b-button
        class="ml-2"
        variant="danger"
        @click="hideModal('deleteRulesGrouping' + ruleGroup.id)"
      >
        Abbrechen
      </b-button>
    </b-modal>
  </div>
</template>

<script>
import {
  DeleteRule,
  DeleteGroupedRule,
  GetRuleValues,
  SaveRule,
} from "@/services/minimum.wage.services/rules.minimum.wages.js";
import RuleEdit from "@/components/minimum.wage/pages/Rules/RuleEdit.vue";
import RuleGroupConfiguration from "@/components/minimum.wage/pages/Rules/RuleGroupConfiguration.vue";
import RuleBulkEdit from "@/components/minimum.wage/pages/Rules/RuleBulkEdit.vue";
import RuleBulkDelete from "@/components/minimum.wage/pages/Rules/RuleBulkDelete.vue";
import RuleBulkCopyMove from "./RuleBulkCopyMove.vue";
import { GetPossibleStructureValues } from "@/services/minimum.wage.services/criteria.minimum.wages.js";
import { MinimumWageMixin } from "@/components/minimum.wage/mixins/MinimumWageMixin";

export default {
  components: {
    RuleEdit,
    RuleGroupConfiguration,
    RuleBulkEdit,
    RuleBulkDelete,
    RuleBulkCopyMove,
  },
  mixins: [MinimumWageMixin],
  props: {
    ruleGroup: {
      type: Object,
      required: true,
    },
    configuration: {
      type: Object,
      required: true,
    },
    contractId: {
      type: String,
      default: "",
    },
    versionId: {
      type: Number,
      default: 0,
    },
    editionId: {
      type: Number,
      default: 0,
    },
    expandedGroups: {
      type: Array,
      default: () => [],
    },
    pagination: {
      type: Object,
      default: () => {
        return {};
      },
    },
    allGroups: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      selected: [],
      isLoading: false,
      deleteErrorObject: null,
      saveRuleError: null,
      tableHeaders: [],
      listItems: [],
      previousStructureProperties: [],
      ruleToEdit: null,
      ruleToDelete: -1,
      rowsPerPage: [{ text: "Alle", value: -1 }, 10, 25, 50, 100],
      criteriaStructureOptions: [],
      groupedItemsHistory:
        this.$store.state.history.mindestLohnKonfiguration.ruleConfiguration
          .groupedRulesConfig,
      shouldEmitChangedEvent: false,
    };
  },
  computed: {
    isExpanded() {
      return this.expandedGroups.includes(this.ruleGroup.id);
    },
    highestGroupOrder() {
      if (this.listItems && this.listItems.length > 0) {
        return Math.max(
          ...this.listItems
            .filter((item) => item.ruleGroupId == this.ruleGroup.id)
            .map((item) => item.order),
        );
      }
      return 0;
    },
  },
  watch: {
    isExpanded(newValue) {
      if (newValue) {
        this.GetAllValuesForRule(true);
      }
    },
  },

  created() {
    if (this.isExpanded) {
      this.GetAllValuesForRule(true);
    }

    this.tableHeaders = [];
    this.criteriaStructureOptions = [];

    this.tableHeaders.push({
      text: "Sortierung",
      sortable: true,
      value: "order",
    });

    this.configuration.configEntries.map((config) => {
      if (config.criteriaStructureId) {
        this.getAllOptions(
          config.criteriaStructure.id,
          config.criteriaStructure.name,
        );

        this.tableHeaders.push({
          text: JSON.parse(JSON.stringify(config.criteriaStructure.name)),
          sortable: true,
          value: "criteriaStructureId" + config.criteriaStructureId,
        });
      }

      if (config.criteriaGroupId) {
        this.tableHeaders.push({
          text: JSON.parse(JSON.stringify(config.criteriaGroup.name)),
          sortable: true,
          value: "criteriaGroupId" + config.criteriaGroupId,
        });
      }

      if (config.variableId) {
        this.tableHeaders.push({
          text: JSON.parse(JSON.stringify(config.variable.name)),
          sortable: true,
          value: "variableId" + config.variableId,
        });
      }
    });

    this.tableHeaders.push({
      text: "Aktion",
      sortable: false,
    });

    this.createPreviousStructureProperties();
  },
  methods: {
    handlePaginationChange(pagination) {
      this.$emit("togglePagination", pagination);
    },
    handleChange() {
      this.shouldEmitChangedEvent = true;
      this.GetAllValuesForRule(true);
    },
    selectProperty(item, header) {
      var allItems = JSON.parse(JSON.stringify(this.listItems));

      allItems = allItems.filter((filterItem) => {
        return item[header.value] === filterItem[header.value];
      });

      this.selected = JSON.parse(JSON.stringify(allItems));
    },
    getAllOptions(criteriaStructureId, type) {
      this.isLoading = true;
      GetPossibleStructureValues(
        this.contractId,
        this.versionId,
        this.editionId,
        criteriaStructureId,
        [],
        true,
        false,
        (response) => {
          if (response) {
            const criteriaTitels = [];
            response.forEach((criteria) => {
              if (!criteriaTitels.includes(criteria.selectionGroupTitle)) {
                criteriaTitels.push(criteria.selectionGroupTitle);
              }
            });

            if (criteriaTitels.length > 1) {
              this.criteriaStructureOptions.push(
                JSON.parse(JSON.stringify(response)),
              );
              let indexOfCriteria = 0;
              this.tableHeaders.forEach((tableHeader, index) => {
                if (tableHeader.text == type) {
                  indexOfCriteria = index;
                }
              });
              this.tableHeaders.splice(indexOfCriteria, 0, {
                text: "Titel Abhängige Liste",
                sortable: true,
                value: "criteriaStructureOption" + criteriaStructureId,
              });

              this.GetAllValuesForRule(true);
            }

            this.isLoading = false;
          }
        },
        (error) => {
          console.log(error);
        },
      );
    },
    switchSelection() {
      var allItems = JSON.parse(JSON.stringify(this.listItems));
      var selectedCopy = JSON.parse(JSON.stringify(this.selected));

      for (let index = 0; index < selectedCopy.length; index++) {
        var objectIndex = -1;

        for (var i = 0, len = allItems.length; i < len; i++) {
          if (
            JSON.stringify(allItems[i]) === JSON.stringify(selectedCopy[index])
          ) {
            objectIndex = i;
            break;
          }
        }

        allItems.splice(objectIndex, 1);
      }

      this.selected = JSON.parse(JSON.stringify(allItems));
    },
    hideModal(modalId) {
      this.$refs[modalId].hide();
    },
    createPreviousStructureProperties() {
      this.previousStructureProperties = [];
    },
    saveRule(rule) {
      this.isLoading = true;

      var ruleToSave = {
        id: rule.id,
        ruleConfigurationId: 0,
        ruleGroupId: rule.ruleGroupId,
        order: 0,
        entries: [],
      };

      for (var prop in rule) {
        if (Object.prototype.hasOwnProperty.call(rule, prop)) {
          if (prop.indexOf("criteriaStructureId") != -1) {
            var propertyId = prop.replace("criteriaStructureId", "");
            ruleToSave.entries.push({
              id: rule["IdCriteriaStructureId" + propertyId],
              ruleId: rule.ruleGroupId,
              criteriaStructureId: propertyId,
              criteriaGroupId: 0,
              variableId: 0,
              value: rule[prop],
              criteriaListEntryId: 0,
            });
          }

          if (prop.indexOf("criteriaGroupId") != -1) {
            var propertyId2 = prop.replace("criteriaGroupId", "");
            ruleToSave.entries.push({
              id: rule["IdCriteriaGroupId" + propertyId2],
              ruleId: rule.ruleGroupId,
              criteriaStructureId: 0,
              criteriaGroupId: propertyId2,
              variableId: 0,
              value: rule[prop],
              criteriaListEntryId: 0,
            });
          }

          if (prop.indexOf("variableId") != -1) {
            var propertyId3 = prop.replace("variableId", "");
            ruleToSave.entries.push({
              id: rule["IdVariableId" + propertyId3],
              ruleId: rule.ruleGroupId,
              criteriaStructureId: 0,
              criteriaGroupId: 0,
              variableId: propertyId3,
              value: rule[prop],
              criteriaListEntryId: 0,
            });
          }
        }
      }

      SaveRule(
        this.contractId,
        this.versionId,
        this.editionId,
        this.configuration.id,
        ruleToSave,
        () => {
          this.hideModal("editRule" + this.ruleGroup.id);
          this.handleChange();
        },
        (error) => {
          this.isLoading = false;
          this.saveRuleError = error;
        },
      );
    },
    deleteGroupedRule() {
      DeleteRule(
        this.contractId,
        this.versionId,
        this.editionId,
        this.configuration.id,
        this.ruleToDelete,
        () => {
          this.hideModal("confirmDeleteGroupedRule" + this.ruleGroup.id);
          this.handleChange();
        },
        (error) => {
          this.deleteErrorObject = error;
        },
      );
    },
    deleteGrouping() {
      DeleteGroupedRule(
        this.contractId,
        this.versionId,
        this.editionId,
        this.configuration.id,
        this.ruleGroup.id,
        () => {
          this.hideModal("deleteRulesGrouping" + this.ruleGroup.id);
          this.handleChange();
        },
        (error) => {
          this.deleteErrorObject = error;
        },
      );
    },
    GetAllValuesForRule(showLoading) {
      this.isLoading = showLoading;
      this.errorObject = null;

      GetRuleValues(
        this.contractId,
        this.versionId,
        this.editionId,
        this.configuration.id,
        (response) => {
          this.listItems = [];

          response.map((item) => {
            if (item.ruleGroupId == this.ruleGroup.id) {
              var itemObject = {
                itemId: response.id,
                ruleGroupId: item.ruleGroupId,
                id: item.id,
                order: item.order,
              };

              item.entries.map((entry) => {
                if (entry.criteriaStructureId) {
                  itemObject[
                    "criteriaStructureId" + entry.criteriaStructureId
                  ] = entry.value;
                  if (this.criteriaStructureOptions.length > 0) {
                    this.criteriaStructureOptions.forEach(
                      (criteriaStructureOption) => {
                        criteriaStructureOption.forEach((option) => {
                          if (
                            option.value == entry.value &&
                            option.criteriaListEntryId ==
                              entry.criteriaListEntryId
                          ) {
                            itemObject[
                              "criteriaStructureOption" +
                                entry.criteriaStructureId
                            ] = option.selectionGroupTitle;
                          }
                        });
                      },
                    );
                  }
                }

                if (entry.criteriaGroupId) {
                  itemObject["criteriaGroupId" + entry.criteriaGroupId] =
                    entry.value;
                }

                if (entry.variableId) {
                  itemObject["variableId" + entry.variableId] = entry.value;
                }
              });

              this.listItems.push(itemObject);
            }
          });

          this.listItems.sort((a, b) => {
            return a.order - b.order;
          });

          if (this.shouldEmitChangedEvent) {
            this.$emit("collectionChanged");
          }

          this.isLoading = false;
        },
        (error) => {
          this.isLoading = false;
          this.errorObject = error;
        },
      );
    },
  },
};
</script>

<style>
#confirmDeleteProperty___BV_modal_content_ {
  margin-top: 40px;
}

.configEntryLine .v-text-field {
  padding: 0px;
  margin: 0px;
}

.specialHeight .v-table__overflow {
  max-height: calc(100vh - 300px);
  overflow-y: auto;
}
</style>

<style scoped>
.cursorpointer {
  cursor: pointer;
}

.noselect {
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none;
  /* Non-prefixed version, currently
                                   supported by Chrome, Edge, Opera and Firefox */
}

.mediumActionButton {
  width: 30px;
  height: 30px;
  padding: 1px;
}

.smallActionButton {
  max-width: 25px;
  min-width: 25px;
  height: 25px;
  font-size: 17px;
  padding: 0px;
}

.groupingWrapper {
  border-bottom: 1px solid rgb(200, 200, 200);
  padding-left: 4px;
}

.groupingTitle {
  font-size: 1.2rem;
  cursor: pointer;
  font-weight: bold;
  padding: 7px 0px;
  padding-left: 4px;
}

.groupingTitle:hover {
  background-color: #f3f3f3;
}

.col05 {
  width: 5%;
  padding-left: 15px;
}

.col10 {
  width: 10%;
}

.col90 {
  width: 85%;
}
</style>
